<template>
    <div class="typeahead">
        <input class="typeahead__input" v-model="userText" @input="userInputHandler"/>
        <div class="typeahead__items-wrapper">
            <div class="typeahead__items" v-show="showList && hasItems">
                <div class="typeahead__item" v-for="item in filteredItems" v-on:click="selectHandler(item)">
                    {{item[property]}}
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="stylus">
    @require "../../styles/variables.styl";

    .typeahead
        width 100%
    .typeahead__input
        width 100%
        color $color-main-1
        border 1px solid $color-main-1
        padding .2em .5em
        font-size 1em
        font-family $font-secondary

    .typeahead__items-wrapper
        position relative
        z-index 100

    .typeahead__items
        position absolute
        width 100%
        top -2px

    .typeahead__item
        line-height 1.2em
        cursor pointer
        font-size .9em
        padding .5em
        border 1px solid $color-main-1
        border-top none
        background-color #fff
        &:first-child
            border-top 1px solid $color-main-1
        &:hover
            background-color lighten($color-main-1, 30);
</style>
<script>

export default {
    props: {
        items: Array,
        property: String
    },
    data() {
        return {
            userText: '',
            filteredItems: [],
            selectedItem: null,
            showList: false
        }
    },
    computed: {
        hasItems() {
            return this.items;
        },
        isActive(item) {
            return item === this.selectedItem
        }
    },
    watch: {
        'userText': function() {
            let result = [];
            if (this.items && this.property) {
                result = this.items.filter( item => {
                    console.log(item[this.property].indexOf(this.userText));
                    return item[this.property].toLowerCase().indexOf(this.userText.toLowerCase()) !== -1;
                });
            }
            this.filteredItems = result.slice(0, 5);

            /* If the user doesn't select an item from the list, but uses free text. */
            if (this.filteredItems.length === 0) {
                this.freeTextHandler(this.userText);
            }
        }
    },
    mounted() {
        this.userText = '';
    },
    methods: {
        freeTextHandler(text) {
            const result = {
                _type: 'freetext'
            };
            result[this.property] = text;
            this.$emit('select', result)
        },
        selectHandler(item) {
            this.selectedItem = item;
            this.userText = item[this.property];
            this.showList = false;
            this.$emit('select', item);
        },
        userInputHandler() {
            console.log('userinput');
            this.showList = true;
        }
    }
}
</script>


// WEBPACK FOOTER //
// typeahead.vue?06f43e01